import { createFileRoute } from '@tanstack/react-router'
import AssetHealth from '@/views/asset_health/asset_health'

export const Route = createFileRoute(
  '/_authenticated/_staff/sensor-kit-health',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <AssetHealth />
}
